/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AcademicEventCategory } from '../models/AcademicEventCategory';
import type { AcademicEventDtoPaginationResponseResponse } from '../models/AcademicEventDtoPaginationResponseResponse';
import type { AcademicEventDtoResponse } from '../models/AcademicEventDtoResponse';
import type { BooleanResponse } from '../models/BooleanResponse';
import type { CreateAcademicEventCommand } from '../models/CreateAcademicEventCommand';
import type { UpdateAcademicEventCommand } from '../models/UpdateAcademicEventCommand';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AcademicEventService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param search
     * @param sortField
     * @param isSortAscending
     * @param category
     * @param showPastEvents
     * @param pageNumber
     * @param pageSize
     * @returns AcademicEventDtoPaginationResponseResponse Success
     * @throws ApiError
     */
    public getApiAcademicEventSearch(
        search?: string,
        sortField?: string,
        isSortAscending?: boolean,
        category?: AcademicEventCategory,
        showPastEvents?: boolean,
        pageNumber?: number,
        pageSize?: number,
    ): CancelablePromise<AcademicEventDtoPaginationResponseResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/AcademicEvent/search',
            query: {
                'Search': search,
                'SortField': sortField,
                'IsSortAscending': isSortAscending,
                'Category': category,
                'ShowPastEvents': showPastEvents,
                'PageNumber': pageNumber,
                'PageSize': pageSize,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns AcademicEventDtoResponse Success
     * @throws ApiError
     */
    public postApiAcademicEventCreate(
        requestBody?: CreateAcademicEventCommand,
    ): CancelablePromise<AcademicEventDtoResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/AcademicEvent/create',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns AcademicEventDtoResponse Success
     * @throws ApiError
     */
    public putApiAcademicEventUpdate(
        requestBody?: UpdateAcademicEventCommand,
    ): CancelablePromise<AcademicEventDtoResponse> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/AcademicEvent/update',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param id
     * @returns BooleanResponse Success
     * @throws ApiError
     */
    public deleteApiAcademicEventDelete(
        id: string,
    ): CancelablePromise<BooleanResponse> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/AcademicEvent/delete/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
}
